import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 13009B66-7459-4C86-8EB0-3CAED977BB98
 * name surround-sound-2-0
 * version: 2.0.46
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/surround-sound-2-0.svg
 * tags
 * - Audio 
 */
export const SurroundSound20Icon = createSvgIcon(<><path d="M3 7V9H7V11H5C3.9 11 3 11.9 3 13V17H9V15H5V13H7C8.1 13 9 12.1 9 11V9C9 7.9 8.1 7 7 7H3M13 17H11V15H13V17M17 7C15.9 7 15 7.9 15 9V15C15 16.1 15.9 17 17 17H19C20.1 17 21 16.1 21 15V9C21 7.9 20.1 7 19 7H17M17 9H19V15H17V9Z" /></>, 'SurroundSound20Icon');
export default SurroundSound20Icon